import TransactionInfoModal from './modals/TransactionInfoModal';

export const modals = {
  "TRANSACTION_INFO": TransactionInfoModal
};

export default modals;
